import { format } from 'date-fns';
import { frCA } from 'date-fns/locale';

import Component from '../classes/component';
import Calendar from './calendar';

const SELECTORS = {
  form: '#checkout',
  submit: '#place_order',
  commentInput: 'input[name="order_comments"]',
};

class Payment extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _getCommentLine(): string {
    const { date, from, to } = this._getChildComponent<Calendar>('calendar').getSelection();
    const formattedDate = format(date, 'PPPP', { locale: frCA });

    return `La commande sera ramassée le ${formattedDate} entre ${from} et ${to}.`;
  }

  private _handlePlaceOrder() {
    const form = this._getChild<HTMLFormElement>('form');

    const commentInput = this._getChild<HTMLInputElement>('commentInput');
    if (commentInput) commentInput.value = this._getCommentLine();

    jQuery(form).triggerHandler('submit');
  }

  protected _onEnter() {
    this._addListener('submit', 'click', this._handlePlaceOrder);
  }
}

export default Payment;
